// extracted by mini-css-extract-plugin
export default {"nameform":"style_nameform__yp4Sq","input":"style_input__pm0S2"};